import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class SaasClientActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Saas/SaasClient/SaasClientBrowser")
	}

	render() {
		return (
			<Activity 
				name="SaasClient"
				RenderedComponent={this.RenderedComponent}
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(SaasClientActivity)
